/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var slideDownCustom = function slideDown(element, callback) {
        var animationQueue = {}
        var propertyToAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'height';

        // To do the animation we temporarily hide it, check the height, and transition to it
        element.style[propertyToAnimate] = element.scrollHeight + 'px';

        var transitionEnded = function transitionEnded(event) {
          if (event.propertyName === propertyToAnimate) {
            var defaultValue = 'auto';

            if (propertyToAnimate === 'max-height') {
              defaultValue = 'none';
            }

            element.style[propertyToAnimate] = defaultValue; // Allows the content to grow normally
            element.removeEventListener('transitionend', transitionEnded);
            delete animationQueue[element.id];

            (callback || function () {})();
          }
        };

        element.addEventListener('transitionend', transitionEnded);
        animationQueue[element.id] = transitionEnded;
      }

document.addEventListener("DOMContentLoaded", function(event) { 
//   function wrap(el, wrapper) {
//     el.parentNode.insertBefore(wrapper, el);
//     wrapper.appendChild(el);
//   }
  
  var showProductAccessoriesBtnOpen = document.querySelector('.show-product-accessories-btn.open-btn');
  var showProductAccessoriesBtnClose = document.querySelector('.show-product-accessories-btn.close-btn');
  var productAccessories = document.getElementById('w3-product-accessories');
  var productInfoElement = document.querySelector('.product-block-list__item--info .card');
  var productAccessoriesTitle = document.querySelector('.product-accessories-title');
  if (showProductAccessoriesBtnOpen && showProductAccessoriesBtnClose && productAccessories) {
    showProductAccessoriesBtnOpen.addEventListener("click", function(e) {
      e.preventDefault();
      productAccessories.classList.add('open');
      showProductAccessoriesBtnOpen.classList.add('opened');
      showProductAccessoriesBtnClose.classList.add('opened');
      
      var checkHeight = function(){
        if (productInfoElement) {
          document.querySelector('.product-block-list__wrapper').style.minHeight = productInfoElement.clientHeight + 'px';
        }else{
          return false; 
        }
      }
      
      slideDownCustom(productAccessories, checkHeight, 'max-height');
      
     
    });
    
    showProductAccessoriesBtnClose.addEventListener("click", function(e) {
      e.preventDefault();
      productAccessories.classList.remove('open');
      showProductAccessoriesBtnClose.classList.remove('opened');
      showProductAccessoriesBtnOpen.classList.remove('opened');
      
      
      productAccessories.style['max-height'] = productAccessories.offsetHeight + 'px';
      productAccessories.offsetHeight; // Use to force a redraw
      productAccessories.style['max-height'] = null; // Remove the attribute to let the CSS decide the max-height


      if (productAccessoriesTitle) {
        var amountToScroll = productAccessoriesTitle.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
       window.scrollBy({ top: amountToScroll, behavior: 'smooth' });
      }
            
      if (productInfoElement) {
        document.querySelector('.product-block-list__wrapper').style.minHeight = productInfoElement.clientHeight + 'px';
      }
    });
  }
  
  function changeAccessoriesElements (container) {
    var accessoryVariantSelects = container.querySelectorAll('.accessory-variant-select');
    var accessoryVariantSelectWrapper = document.createElement('div');
    accessoryVariantSelectWrapper.setAttribute('class', 'accessory-variant-select-wrapper');
    accessoryVariantSelects.forEach(function(item){
      wrap(item, accessoryVariantSelectWrapper);
    })
  }
  
  if (productAccessories) { 
    (function doCheck(){
      setTimeout(function(){
        var productAccessoriesLoading = document.getElementById('w3-accessories-loading');
        var productAccessoriesItem = productAccessories.querySelector('.accessories-item');
        if (productAccessories.classList.contains("loaded") && !productAccessoriesLoading && productAccessoriesItem) {
          if (productAccessories.style.display == '') {
          	showProductAccessoriesBtnOpen.classList.remove('hidden');
            productAccessoriesTitle.classList.remove('hidden');
            //changeAccessoriesElements (productAccessories);
          }
        }else{
          doCheck();
        }
      }, 100);
    })();
  }
});
